import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { AppSettings } from 'src/app/app.settings';
import { Router } from '@angular/router';
import { Settings } from 'src/app/app.settings.model';
import { FindTimeService } from 'src/app/core/services/find-time.service';

import { MatCheckboxChange } from '@angular/material/checkbox';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { AppData } from 'src/app/app.data';
import { NumericLiteral } from 'typescript';

@Component({
  selector: 'app-pricelist-code-row',
  templateUrl: './pricelist-code-row.component.html',
  styleUrls: ['./pricelist-code-row.component.scss']
})
export class PricelistCodeRowComponent implements OnInit {

  @Input() priceListCode: PriceListCode;
  @Input() odd: boolean;
  @Input() even: boolean;
  @Input() canChangePrice: boolean; // can change price only for creating new appointment
  showDescription = false;



  constructor(private router: Router,
    private findTimeService: FindTimeService,
    private appData: AppData,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.canChangePrice = this.appData.appointment == null;
    this.priceListCode.Selected = this.appData.priceListCodesContains(this.priceListCode.PriceListRefID);

  }

  onSelect(event) {
    // selected one item from series
    this.appData.priceListCodes = [this.priceListCode];
    this.router.navigate(['/find-time']);
  }


  onChange(event: MatCheckboxChange) {
    // multiple items can be selected (except from series)
    if (event.checked) {
      this.appData.addToPriceListCodes(this.priceListCode);
    } else {
      this.appData.removeFromPriceListCodes(this.priceListCode.PriceListRefID);
    }
  }

  onChangePrice(event) {
    
    var value = event.target.value;
    var newPrice = parseFloat(value) || 0;
    var shouldRefrshDom = false;
    if (isNaN(newPrice) || newPrice < 0) {
      newPrice = 0;
      shouldRefrshDom = true;
    }

    this.priceListCode.FinalPrice = newPrice;
    if (this.appData.priceListCodesContains(this.priceListCode.PriceListRefID)) {
      this.appData.removeFromPriceListCodes(this.priceListCode.PriceListRefID);
      this.appData.addToPriceListCodes(this.priceListCode);
    }

    if(shouldRefrshDom){
      // refresh the dom if change was canceled
      this.cd.detectChanges();
    }

  }

}
